export default {
  views: {},
  activeViewId: null,
  loading: false,
  loaded: false,
};
